<template>
    <v-dialog persistent width="430" :value="isPopup">
        <div class="filesWrapper">
            <div class="popupHead">Renewal value
                <button type="button" @click="onClose">
                    <svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
                </button>
            </div>
            <div class="subHead">Trailer# <span class="number">{{trailerNumber}}</span></div>
            <div class="groupField_wrap">
                <field
                    width="200px"
                    margin="0 10px 0 0"
                    label="Origin value"
                    :setInputValue="originValue"
                    icon="dollar"
                    isReadonly
                ></field>
                <field
                    :class-error="$v.renewalValue && $v.renewalValue.$error"
                    width="200px"
                    margin="0"
                    label="Value"
                    placeholder="Enter value"
                    :setInputValue="renewalValue"
                    @updateInput="onInput($event, 'renewalValue')"
                    icon="dollar"
                    is-required
                    isNumber
                    type="number"
                    minValue="1"
                ></field>
            </div>
            <div class="groupField_wrap">
                <field
                    :class-error="$v.yearFrom && $v.yearFrom.$error"
                    width="200px"
                    margin="0 10px 0 0"
                    label="Year from"
                    placeholder="Select year from"
                    @updateAutocomplete="onAutocomplete($event, 'yearFrom')"
                    @updateSearchText="onSearchText"
                    item-text="value"
                    :autocompleteValue="yearFrom"
                    :items="itemsYears"
                    :isClearable="false"
                    is-autocomplete
                    is-required
                ></field>
                <field
                    :class-error="$v.yearTo && $v.yearTo.$error"
                    width="200px"
                    margin="0"
                    label="Year to"
                    placeholder="Select year to"
                    @updateAutocomplete="onAutocomplete($event, 'yearTo')"
                    @updateSearchText="onSearchText"
                    item-text="value"
                    :autocompleteValue="yearTo"
                    :items="itemsYears"
                    :isClearable="false"
                    is-autocomplete
                    is-required
                ></field>
            </div>
            <field
                margin="0 0 20px 0"
                padding="10px 10px 0 10px"
                width="390px"
                label="Notes"
                placeholder="Some text..."
                :setInputValue="note"
                @updateInput="onInput($event, 'note')"
                is-textarea
            ></field>
            <button-groups @updateBtnClose="onClose" @updateSave="onSave"></button-groups>
        </div>
    </v-dialog>
</template>

<script>
import { validationMixin } from "vuelidate";
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups";
import { required, numeric, minValue } from "vuelidate/lib/validators";

export default {
	name: "RenewalValuePopup",
	mixins: [ validationMixin ],
	components: {
		ButtonGroups
	},
	props: {
		itemsYears: Array,
		editItem: Object,
		trailerNumber: String,
		originValue: Number,
	},
	data: () => ({
		isPopup: true,
		yearFrom: null,
		yearTo: null,
		id: null,
		renewalValue: '',
		note: '',
		values: null,
	}),
	validations: {
		yearFrom: { required },
		yearTo: { required },
		renewalValue: { required, numeric, minValue: minValue(1) }
	},
	methods: {
		onClose() {
			this.$emit('updateClose');
		},
		onAutocomplete({ value }, key) {
			this[key] = value?.values ?? value;
		},
		onSearchText(name) {
			this.$emit('updateSearchText', name);
		},
		onInput({ value }, key) {
			this[key] = value;
		},
		onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const {
					yearFrom,
					yearTo,
					renewalValue,
					note,
					id
				} = this.$data;

				const values = {
					yearFrom: yearFrom.id ? yearFrom.id : yearFrom,
					yearTo: yearTo.id ? yearTo.id : yearTo,
					renewalValue,
					note,
					id,
				};
				this.$emit('updateRenewalValueList', values);
				this.onClose();
			}
		}
	},
	mounted() {
		if (this.editItem) {
			const {
				id,
				note,
				period_end,
				period_start,
				renewal,
			} = this.editItem;

			this.yearFrom = period_start;
			this.yearTo = period_end;
			this.renewalValue = renewal;
			this.note = note;
			this.id = id;
		}
	}
};
</script>

<style scoped lang="scss">
@import "../../../Trucks/TruckForm/RenewalValuePopup/RenewalValuePopup";
</style>
<style lang="scss">
.equipmentCheckbox .v-label{
    font-size: 14px;
    line-height: 20px;
}
</style>
